import FeathersHelper from "../../helpers/feathers";

export const find = (payload) =>
  FeathersHelper.find('announcements', payload);
export const create = (payload) =>
  FeathersHelper.create('announcements', payload);
export const patch = (id, payload, params = {}) => FeathersHelper.patch('announcements', id, payload, params);
export const remove = (id, params = {}) => FeathersHelper.remove('announcements', id, params);

